<template>
  <div class="page flex-col">
    <div class="block_1 flex-col">
      <div class="group_1 flex-row">
        <img
          class="label_1"
          referrerpolicy="no-referrer"
          :src="
            domainName == '灵智鸟'
              ? require('@/assets/public/logo48.png')
              : require('@/assets/public/logo48-2.png')
          "
        />
        <span class="text_1">{{ domainName }}</span>
      </div>
      <div class="group_2 flex-col">
        <div class="box_1 flex-row justify-between">
          <div
            class="block_2 flex-col"
            @click="onClick(0)"
            :class="idx === 0 ? 'selected' : ''"
          >
            <div class="box_2 flex-col"></div>
            <span class="text_2">用户名和密码</span>
          </div>
          <!-- <div class="block_2 flex-col" @click="onClick(1)" :class="idx === 1 ? 'selected':''">
            <div class="box_2 flex-col"></div>
            <span class="text_2">课堂登录码</span>
          </div> -->
        </div>
        <!-- 用户名和密码登录 -->
        <div
          class="box_3 flex-col"
          v-show="idx === 0"
        >
          <span class="text_4">学生登录</span>
          <div class="section_1 flex-row justify-between">
            <img
              class="label_2"
              referrerpolicy="no-referrer"
              src="../../assets/student/login/FigmaDDSSlicePNG89ae4ce48265dcbf9d70c49e18522a27.png"
            />
            <div class="box_4 flex-col justify-end">
              <input
                class="text_5"
                type="text"
                placeholder="请输入用户名"
                v-model="username"
              />
            </div>
          </div>
          <div class="section_2 flex-row justify-between">
            <img
              class="label_3"
              referrerpolicy="no-referrer"
              src="../../assets/student/login/FigmaDDSSlicePNG020eed6b24333a4475f41556036cf386.png"
            />
            <div class="block_3 flex-col justify-end">
              <input
                class="text_6"
                type="password"
                placeholder="请输入密码"
                v-model="password"
                @keyup.enter="loginClick"
              />
            </div>
          </div>
          <div
            class="text-wrapper_2 flex-col"
            @click="loginClick"
          >
            <span class="text_7">登录</span>
          </div>
        </div>
        <!-- 课堂登录码登录 -->
        <div
          class="box_3 flex-col"
          v-show="idx === 1"
        >
          <div class="bblock_2 flex-col">
            <span class="btext_4">学生登录</span>
            <div class="bbox_5 flex-row justify-between">
              <img
                class="blabel_2"
                referrerpolicy="no-referrer"
                src="../../assets/student/login/FigmaDDSSlicePNG020eed6b24333a4475f41556036cf386.png"
              />
              <div class="bbox_6 flex-col justify-end">
                <input
                  class="btext_5"
                  type="text"
                  placeholder="请输入课堂登录码"
                />
                <!-- <div class="bsection_1 flex-col"></div> -->
              </div>
            </div>
            <div
              class="btext-wrapper_2 flex-col"
              @click="loginClick"
            >
              <span class="btext_6">登录</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
import { useRouter } from "vue-router"
import md5 from "js-md5"

import alovaInstance from "@/utils/alova"
import { getDomainName } from "@/utils/domainConfig"

const router = useRouter()
const idx = ref(0)

const username = ref("")
const password = ref("")

// 根据域名获取配置
const domainName = computed(() => getDomainName())

const onClick = (index) => {
  idx.value = index
}

const loginClick = async () => {
  if (idx.value === 0) {
    if (!username.value) {
      alert("请输入用户名")
      return
    }
    if (!password.value) {
      alert("请输入密码")
      return
    }
    const encryptedPassword = md5(password.value)
    let response = await alovaInstance.Post("/Student/Login", {
      loginName: username.value,
      password: encryptedPassword,
    })
    // console.log(response);
    if (response.code === 1000) {
      localStorage.setItem("jwt_student_token", response.data.sessionToken)
      router.push({ name: "Lesson" })
    } else {
      // localStorage.removeItem("jwt_token")
      alert("登录失败，用户名或密码错误")
    }
  }
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.block_1 {
  width: 100vw;
  height: 56.25vw;
  background: url(../../assets/student/login/FigmaDDSSlicePNGd1b93c07a029e6f811df8fef698d0b86.png)
    100% no-repeat;
  background-size: 100% 100%;
}

.group_1 {
  background-color: rgba(34, 76, 123, 1);
  width: 100vw;
  height: 2.87vw;
}

.label_1 {
  width: 2.09vw;
  height: 2.09vw;
  margin: 0.3vw 0 0 2.91vw;
}

.text_1 {
  width: 7.5vw;
  height: 2.4vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.4vw;
  font-family: Microsoft YaHei UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.88vw;
  margin: 0.4vw 0 0 0.8vw;
}

.group_2 {
  width: 100vw;
  height: 52.45vw;
  margin-bottom: 0.06vw;
}

.box_1 {
  width: 20.16vw;
  height: 2.92vw;
  margin: 9vw 0 0 33.02vw;
}

.block_2 {
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 16px 16px 0px 0px;
  height: 2.66vw;
  margin-top: 0.27vw;
  width: 9.07vw;
  cursor: pointer;
}

.selected {
  background-color: rgba(255, 255, 255, 1);
  width: 10.42vw;
  height: 2.92vw;
}

.selected > .box_2 {
  background-color: rgba(104, 162, 250, 1);
  border-radius: 6px;
  width: 9.38vw;
  height: 0.21vw;
  margin-left: 0.53vw;
}

.selected > .text_2 {
  width: 7.19vw;
  height: 1.46vw;
  overflow-wrap: break-word;
  color: rgba(74, 74, 74, 1);
  font-size: 1.14vw;
  font-family: Microsoft YaHei UI-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.15vw;
  margin: 0.5vw 0 0.83vw 1.66vw;
}

.text_2 {
  width: 7.19vw;
  height: 1.31vw;
  overflow-wrap: break-word;
  color: rgba(110, 110, 110, 1);
  font-size: 1.14vw;
  font-family: Microsoft YaHei UI-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.15vw;
  margin: 0.78vw 0 0 0.98vw;
}

.box_3 {
  box-shadow: 2px 2px 6px 3px rgba(12, 12, 13, 0.05);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 24px;
  width: 36.46vw;
  height: 22.3vw;
  margin: 0 0 14.89vw 31.77vw;
}

.text_4 {
  width: 18.13vw;
  height: 2.04vw;
  overflow-wrap: break-word;
  color: rgba(104, 162, 250, 1);
  font-size: 1.66vw;
  font-family: Inter-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 2.23vw 0 0 9.16vw;
}

.section_1 {
  width: 17.71vw;
  height: 2.09vw;
  margin: 3.28vw 0 0 9.16vw;
}

.label_2 {
  width: 2.09vw;
  height: 2.09vw;
}

.box_4 {
  background-color: rgba(245, 245, 245, 1);
  border-radius: 4px;
  width: 14.59vw;
  height: 2.09vw;
  border: 1px solid rgba(255, 255, 255, 0);
}

.text_5 {
  width: 12.88vw;
  height: 2vw;
  overflow-wrap: break-word;
  color: rgba(112, 112, 112, 1);
  font-size: 0.83vw;
  font-family: Segoe UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 2vw;
  margin: 0 0 0 0.72vw;
  background-color: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid transparent;
  padding-bottom: 2px;
}

.text_5:focus {
  border-image: linear-gradient(
    to right,
    transparent 35%,
    rgba(15, 84, 140, 1) 35%,
    rgba(15, 84, 140, 1) 65%,
    transparent 65%
  );
  border-image-slice: 1;
  outline: none;
}

.section_2 {
  width: 17.71vw;
  height: 2.09vw;
  margin: 1.61vw 0 0 9.16vw;
}

.label_3 {
  width: 2.09vw;
  height: 2.09vw;
}

.block_3 {
  background-color: rgba(245, 245, 245, 1);
  border-radius: 4px;
  width: 14.59vw;
  height: 2.09vw;
  border: 1px solid rgba(255, 255, 255, 0);
}

.text_6 {
  width: 12.88vw;
  height: 2vw;
  overflow-wrap: break-word;
  color: rgba(112, 112, 112, 1);
  font-size: 0.83vw;
  font-family: Segoe UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 2vw;
  margin: 0 0 0 0.72vw;
  background-color: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid transparent;
  padding-bottom: 2px;
}

.text_6:focus {
  border-image: linear-gradient(
    to right,
    transparent 35%,
    rgba(15, 84, 140, 1) 35%,
    rgba(15, 84, 140, 1) 65%,
    transparent 65%
  );
  border-image-slice: 1;
  outline: none;
}

.text-wrapper_2 {
  background-color: rgba(104, 162, 250, 1);
  border-radius: 4px;
  height: 2.71vw;
  width: 17.19vw;
  margin: 3.28vw 0 2.96vw 9.63vw;
  cursor: pointer;
}

.text_7 {
  width: 2.09vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.78vw 0 0 7.55vw;
}

.bblock_2 {
  box-shadow: 2px 2px 6px 3px rgba(12, 12, 13, 0.05);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 24px;
  width: 36.46vw;
  height: 22.3vw;
  margin: 0;
}

.btext_4 {
  width: 18.13vw;
  height: 2.04vw;
  overflow-wrap: break-word;
  color: rgba(104, 162, 250, 1);
  font-size: 1.66vw;
  font-family: Inter-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 2.23vw 0 0 9.16vw;
}

.bbox_5 {
  width: 17.71vw;
  height: 2.09vw;
  margin: 5.1vw 0 0 9.16vw;
}

.blabel_2 {
  width: 2.09vw;
  height: 2.09vw;
}

.bbox_6 {
  background-color: rgba(245, 245, 245, 1);
  border-radius: 4px;
  width: 14.59vw;
  height: 2.09vw;
  border: 1px solid rgba(255, 255, 255, 0);
}

.btext_5 {
  width: 12.88vw;
  height: 2vw;
  overflow-wrap: break-word;
  color: rgba(112, 112, 112, 1);
  font-size: 0.83vw;
  font-family: Segoe UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 2vw;
  margin: 0 0 0 0.72vw;
  background-color: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid transparent;
  padding-bottom: 2px;
}

.btext_5:focus {
  border-image: linear-gradient(
    to right,
    transparent 35%,
    rgba(15, 84, 140, 1) 35%,
    rgba(15, 84, 140, 1) 65%,
    transparent 65%
  );
  border-image-slice: 1;
  outline: none;
}

.btext-wrapper_2 {
  background-color: rgba(104, 162, 250, 1);
  border-radius: 4px;
  height: 2.71vw;
  width: 17.19vw;
  margin: 5.1vw 0 3.02vw 9.63vw;
  cursor: pointer;
}

.btext_6 {
  width: 2.09vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Segoe UI-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.78vw 0 0 7.55vw;
}
</style>
